module.exports = __webpack_public_path__ + "img/MSMC_Blue_Transparent_logo_300ppi.f8f4e7b4.png";